import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <main
      className="stage-bg min-h-screen w-full px-6 md:px-16 pt-28 pb-16 md:pt-32 md:pb-24"
      data-testid="privacy-page"
    >
      <div className="max-w-2xl mx-auto">
        <Link
          to="/"
          className="text-[0.72rem] track-sm uppercase link-underline"
          data-testid="privacy-back-link"
        >
          &larr; Back
        </Link>

        <p className="mt-12 text-sm lowercase track-sm" style={{ color: "var(--paper-dim)" }}>
          evove
        </p>
        <h1 className="headline text-3xl md:text-4xl mt-4">Privacy Policy</h1>

        <div
          className="mt-10 space-y-6 text-[0.95rem] leading-relaxed"
          style={{ color: "var(--paper-dim)" }}
        >
          <p>
            Evove Skincare Private Limited (&ldquo;evove&rdquo;, &ldquo;we&rdquo;)
            collects the name and WhatsApp number you provide on our waitlist
            solely to notify you about our launch and related product updates.
          </p>
          <p>
            By joining the waitlist and ticking the consent box, you agree to
            receive these updates from evove on WhatsApp. We record your consent
            and the time it was given alongside your submission.
          </p>
          <p>
            We do not sell your data. You can ask us to remove your details at
            any time by replying &ldquo;STOP&rdquo; to any WhatsApp message from
            us, after which we will delete your information from our waitlist.
          </p>
          <p>
            We retain your details only until launch communications are complete
            or until you ask us to delete them, whichever is earlier.
          </p>
        </div>

        <p
          className="mt-16 text-[0.68rem] smallcaps"
          style={{ color: "var(--paper-faint)" }}
        >
          Evove Skincare Private Limited
        </p>
      </div>
    </main>
  );
}
